var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"size":"mini","plain":"","loading":_vm.loading},on:{"click":_vm.onClick}},[_vm._v("Fetch Nutrients")])}
var staticRenderFns = []

export { render, staticRenderFns }